module.exports = __webpack_public_path__ + "static/media/Garvey-Moran.13dc79ba.png";